import { Component, effect, inject } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';

import { RaceSessionService } from '../../timing-tower/race-session.service';
import { SERIES_NAME } from '../lxp.tokens';

@Component({
	selector: 'vb-lxp-pre-race-page.component',
	imports: [],
	templateUrl: './vb-lxp-pre-race-page.component.html',
	styleUrl: './vb-lxp-pre-race-page.component.css',
})
export class VbLxpPreRacePageComponent {
	private router = inject(Router);
	private route = inject(ActivatedRoute);
	private raceSessionService = inject(RaceSessionService);
	private readonly defaultMessage = 'No track activity at this time.';

	readonly seriesName = inject(SERIES_NAME, { optional: true }) ?? 'default';
	readonly message = this.route.snapshot.queryParamMap.get('preRaceMessage') || this.defaultMessage;

	constructor() {
		effect(() => {
			if (this.raceSessionService.raceTeamsPosition().length > 0) {
				this.router.navigate([''], {
					queryParams: this.route.snapshot.queryParams,
				});
			}
		});
	}
}
